import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { loginAdmin } from '../services/api';

// Styled components
const LoginContainer = styled('div')({
  maxWidth: '450px',
  margin: '120px auto',
  padding: '40px',
  background: '#0a0a0a', // Black background
  borderRadius: '16px',
  boxShadow: '0 12px 35px rgba(0, 0, 0, 0.6)',
  textAlign: 'center',
  border: '1px solid rgba(255, 255, 255, 0.1)',
});

const Title = styled('h1')({
  color: '#ffffff', // White text
  marginBottom: '30px',
  fontSize: '2.2rem',
  fontWeight: '700',
  letterSpacing: '0.8px',
  fontFamily: 'Inter, sans-serif',
});

const ErrorText = styled('p')({
  color: '#ff5555',
  marginBottom: '20px',
  fontSize: '1rem',
  fontFamily: 'Inter, sans-serif',
});

const Input = styled('input')({
  width: '100%',
  padding: '16px',
  marginBottom: '20px',
  background: '#1a1a1a', // Slightly lighter black
  border: '1px solid rgba(255, 255, 255, 0.15)',
  borderRadius: '12px',
  color: '#ffffff', // White text
  fontSize: '1.1rem',
  fontFamily: 'Inter, sans-serif',
  transition: 'all 0.3s ease',
  '&:focus': {
    borderColor: '#ffffff',
    boxShadow: '0 0 12px rgba(255, 255, 255, 0.2)',
    outline: 'none',
  },
});

const LoginButton = styled('button')({
  width: '100%',
  padding: '16px',
  background: 'linear-gradient(90deg, #ffffff, #e0e0e0)',
  color: '#0a0a0a', // Black text on button
  border: 'none',
  borderRadius: '12px',
  fontSize: '1.2rem',
  fontWeight: '600',
  fontFamily: 'Inter, sans-serif',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: '#e0e0e0',
    boxShadow: '0 6px 20px rgba(255, 255, 255, 0.3)',
    transform: 'translateY(-3px)',
  },
});

function Login({ onLogin }) {
  const [username, setUsername] = useState('GIO');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await loginAdmin({ username });
      console.log('API Response:', response); // Debug: Log the response
      if (response.token) {
        localStorage.setItem('adminToken', response.token);
        onLogin();
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      console.error('Login Error:', err); // Debug: Log the error
      setError('Login failed. Please try again.');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <LoginContainer>
        <Title>Admin Login</Title>
        {error && <ErrorText>{error}</ErrorText>}
        <form onSubmit={handleSubmit}>
          <Input
            placeholder="Admin Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <LoginButton type="submit">Login</LoginButton>
        </form>
      </LoginContainer>
    </motion.div>
  );
}

export default Login;